import React, { useState, useEffect,useRef } from 'react';
import "../fees.css";
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/loader';
import {numToCurrency} from "../../../utils/currency"
import noData from "../../../assets/fees/no-data.svg"
import {
    getPaymentGateway,
    getAtomPaymentURL,
    getPaypalPaymentURL,
    getPaymentType,
    getPaymentGatewayChecking,
    getPaymentGatewayFees,
    stateuseData
  } from "../Payment/Payment"
  import PaymentGatewayModal from '../Payment/paymentModel';
 import api from "../../../api/api"
 import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Due_details(props) {
    const { t } = useTranslation();
    const [installments, setInstallments] = useState([]);
    const { setLoading, loading } = props;
    // console.log("razoepay",props.razorpay_fee)
    const { gatewayDta, total_amount, discount, changePaymentType } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedInstallments, setSelectedInstallments] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState([]);
    
        const [cartProducts, setCartProducts] = useState([]);
        const [loader, setLoader] = useState(true);
        const [success, setSuccess] = useState(false);
        const [currencyCode, setCurrencyCode] = useState(null);
        const [countryId, setCountryId] = useState(null);
        const [cartContainMultipleCountryProducts, setCartContainMultipleCountryProducts] = useState(false);
        const [availableOffersBlockOpen, setAvailableOffersBlockOpen] = useState(false);
        const [availableOffers, setAvailableOffers] = useState([]);
        const [totalAmount, setTotalAmount] = useState(null);
        const [totalFee, setTotalFee] = useState(0);

       
    const [gatewayData, setGatewayData] = useState(null);
    const { Atom, Razorpay ,PayPal} = props.pr || {}; 
        const [cartContainPurchasedProducts, setCartContainPurchasedProducts] = useState(false);
        const [buttonDisabled, setButtonDisabled] = useState(false);
        const [loader1, setLoader1] = useState(false);
        const [showAlert, setShowAlert] = useState(false);
        const [heading, setHeading] = useState("");
        const [content, setContent] = useState("");
        const [acceptTc, setAcceptTc] = useState(false);
        const [productInstituteId, setProductInstituteId] = useState("");
        const [addLink, setAddLink] = useState(false);
        const [applyExtraCharge, setApplyExtraCharge] = useState(false);
        const [extraCharge, setExtraCharge] = useState(0);
        const [amountWithCharge, setAmountWithCharge] = useState(0);
        const [showExtraChargePopUp, setShowExtraChargePopUp] = useState(false);
        const [showPaymentPopup, setShowPaymentPopup] = useState(false);
        const [selectPaymentGateway, setSelectPaymentGateway] = useState("razorpay");
        const [showPaymentButton, setShowPaymentButton] = useState(false);
        const [publicToken, setPublicToken] = useState("");
        const [isOAuthDone, setIsOAuthDone] = useState("");
        const [atomData, setAtomData] = useState(null);
    const [razorpayAmount, setRazorpayAmount] = useState(null);
    const paymentModalRef = useRef();

        // useEffect(() => {
        //     onClickPayNow();
        //   }, []);
        const currencySymbol = props?.fetchStudent?.result?.c_symbol === "INR" ? "Rs" : props?.fetchStudent?.result?.c_symbol;

        useEffect(() => {
            if (!paymentData?.length) return;
        
            let totalFeeAmount = paymentData.reduce(
                (sum, item) => sum + item.d_amount + (parseInt(item.balance_fine) || 0),
                0
            );
        
            setTotalFee(totalFeeAmount);
        
           
        }, [paymentData]);
        
        useEffect(() => {
            setLoading(true);  // ✅ Start loader when component mounts
        
            getPaymentGatewayChecking(props, updateData)
                .then(() => setTimeout(() => setLoading(false), 500))  // ⏳ Delay 500ms before stopping loader
                .catch(() => setTimeout(() => setLoading(false), 500)); // ⏳ Handle errors with delay
        
        }, [props.fetchStudent]);
        
            
          useEffect(() => {
            if (atomData) {
                setAtomData('Client', atomData); // ✅ Now inside useEffect
            }
        }, [atomData]);
        
        useEffect(() => {
            if (razorpayAmount !== null) {
                setRazorpayAmount(razorpayAmount); // ✅ Now inside useEffect
            }
        }, [razorpayAmount]);
    // console.log("props",props.fetchStudent)
    useEffect(() => {
        setLoading(true);
    
        if (props?.fetchStudent?.result?.a_install_li) {
            setInstallments(props?.fetchStudent?.result?.a_install_li);
            setTimeout(() => setLoading(false), 800);  
        } else {
            setTimeout(() => setLoading(false), 800);
        }
    }, [props?.fetchStudent]);  
    
    
    

    const getNumberOfDays = (date1, date2) => {
        const diffTime = new Date(date1) - new Date(date2);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    const getFeeStatus = (item) => {
        if (item.p_status === 'N' && item.p_amount === 0 &&  item.bad_debt_amount === 0 && getNumberOfDays(new Date(), item.d_date) > 1) {
            return t('fees.overdue');
        } else if (item.p_status === 'N' && item.p_amount === 0 && item.bad_debt_amount === 0) {
            return t('fees.due');
        } else if (Number(item.initial_amount) + Number(item.tax_amount) - Number(item.disc_amount) === 0) {
            return t('fees.discounted');
        } else if (item.p_status === 'Y') {
            return t('fees.paid');
        } else if (item.p_status === 'N' && item.bad_debt_amount != 0){
            return t('fees.badDebt')
        }
        else {
            return t('fees.partiallyPaid');
        }
    };

    
    // const handleCheckboxChange = (installmentId) => {
    //     setSelectedInstallments((prevSelected) => {
    //         if (prevSelected.includes(installmentId)) {
    //             return prevSelected.filter((id) => id !== installmentId);
    //         } else {
    //             return [...prevSelected, installmentId];
    //         }
    //     });
    // };

    
    // const handleSelectAll = () => {
    //     if (selectAll) {
    //         setSelectedInstallments([]);
    //     } else {
    //         const allInstallmentIds = installments.map((inst) => inst.f_schld_id);
    //         setSelectedInstallments(allInstallmentIds);
    //     }
    //     setSelectAll(!selectAll);
    // };
    const handleCheckboxChange = (installmentId, installNo) => {
        setSelectedInstallments((prevSelected) => {
            let newSelection = [];
    
            if (prevSelected.includes(installmentId)) {
                // 🔴 Case: Uncheck
                if (props.fees_payment_chronological_restrict) {
                    // Restriction ON → remove this and all later installments
                    newSelection = prevSelected.filter((id) => {
                        const inst = installments.find((inst) => inst.f_schld_id === id);
                        return inst && inst.install_no < installNo;
                    });
                } else {
                    // Restriction OFF → just remove this one
                    newSelection = prevSelected.filter((id) => id !== installmentId);
                }
            } else {
                // 🟢 Case: Check
                if (props.fees_payment_chronological_restrict) {
                    // Restriction ON → select all up to this installment
                    newSelection = installments
                        .filter(
                            (inst) =>
                                inst.install_no <= installNo &&
                                getFeeStatus(inst) !== "Paid" &&
                                getFeeStatus(inst) !== "Bad Debt"
                        )
                        .map((inst) => inst.f_schld_id);
                } else {
                    // Restriction OFF → just add this one
                    newSelection = [...prevSelected, installmentId];
                }
            }
    
            // 🔥 Update SelectAll state
            const visibleInstallments = installments
                .filter(
                    (item) =>
                        getFeeStatus(item) !== "Paid" &&
                        getFeeStatus(item) !== "Bad Debt" &&
                        (item.d_amount + parseInt(item?.balance_fine ?? 0)) > 0
                )
                .map((inst) => inst.f_schld_id);
    
            setSelectAll(visibleInstallments.every((id) => newSelection.includes(id)));
    
            return newSelection;
        });
    };
    
    




    
    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedInstallments([]); // Unselect all
        } else {
            // Select only visible installments (filtered in the table)
            const visibleInstallments = installments.filter(
                (item) =>
                    getFeeStatus(item) !== "Paid" &&
                    getFeeStatus(item) !== "Bad Debt" &&
                    (item.d_amount + parseInt(item?.balance_fine ?? 0)) > 0
            ).map((inst) => inst.f_schld_id);
    
            setSelectedInstallments(visibleInstallments);
        }
        setSelectAll(!selectAll);
    };
    

    const handleProceedToPay = () => {
        if (selectedInstallments.length === 0) {
            toast.error("Please select at least one installment to proceed.");
            return;
        }
    
        const selectedInstallmentsData = installments.filter((inst) =>
            selectedInstallments.includes(inst.f_schld_id)
        );
    
        // ✅ Check if selected installments have multiple currencies
        const currencies = selectedInstallmentsData.map(inst => inst.c_code);
        const uniqueCurrencies = new Set(currencies);
    
        if (uniqueCurrencies.size > 1) {
            toast.error("You are not allowed to do payment for multiple currencies.");
            return;
        }
    
        // ✅ Chronological restriction check
        if (!props.fees_payment_chronological_restrict) {
            const selectedInstallNumbers = selectedInstallmentsData.map(inst => inst.install_no);
            const maxSelected = Math.max(...selectedInstallNumbers);
    
            for (let i = 1; i <= maxSelected; i++) {
                const installment = installments.find(inst => inst.install_no === i);
                if (installment &&
                    getFeeStatus(installment) !== "Paid" &&
                    getFeeStatus(installment) !== "Bad Debt" &&
                    !selectedInstallments.includes(installment.f_schld_id)) {
                    toast.error("You need to select your dues first before future payments.");
                    return;
                }
            }
        }
    
        // ✅ Save selected data
        setPaymentData(selectedInstallmentsData);
    
        const selectedSymbol = selectedInstallmentsData[0]?.c_symbol ?? "INR"; // default fallback
    
        // ✅ Check which gateway to use
        if (selectedSymbol === "INR") {
            setIsModalOpen(true); // Razorpay or local gateway modal
        } else {
            const schedule_ids = selectedInstallmentsData.map(inst => inst.f_schld_id);
            const calculatedTotalFee = selectedInstallmentsData.reduce(
                (sum, inst) => sum + (inst.d_amount || 0) + (parseInt(inst.balance_fine) || 0),
                0
            );
            const country_id = props.fetchStudent?.result?.c_b_map?.country_id;
    
            const payload = {
                payment_for: "Fee",
                payment_gateway_account_type: "Client",
                payment_gateway_name: "PayPal",
                country_id: country_id,
                currency_code: selectedSymbol,
                response_code: 200,
                paytab_token: "",
                amount: calculatedTotalFee,
                discription: "",
                online_payment_amount: calculatedTotalFee,
                actual_amount_paid: calculatedTotalFee,
                chequeDetailsJson: {},
                paymentMode: "card",
                payment_source: "WEB",
                institute_id: `${props.institute_id}`,
                paid_date: new Date().toISOString().split('T')[0],
                razor_payment_id: "",
                reference_no: "",
                remarks: "",
                schedule_ids,
                student_id: `${props.student_id}`,
                version: "v2",
                intent: "sale"
            };
    
            if (gatewayData?.PayPal?.is_active === "Y") {
                paypalPayment(payload);
            } else {
                toast.error("PayPal payment option is currently not available.");
            }
        }
    };
    

    const paypalPayment = async(payload) => {
        try {
          setLoader(true);

          const url = await getPaypalPaymentURL(payload);

          if (url && url !== "") {
            window.open(url.replace("redirect:", ""), "_self");
          } else {
            toast.error("Unable to generate payment URL. Please try again.");
          }
        } catch (err) {
          console.error("PayPal payment error:", err);
          toast.error("Could not proceed to payment. Please try again.");
        } finally {
          setLoader(false);
        }
      };
      
    // const paypalPayment = async () => {

    //     let data = selectedInstallments;
      
    //   console.log("data",data)
    //     try {
    //       props.setLoader(true);
    //   console.log("here")
    //   const payload = {
    //     payment_for: "Fee",
    //     payment_gateway_account_type: "Client",
    //     payment_gateway_name: "PayPal",
    //     country_id: 220,
    //     currency_code: props.currency_code,
    //     response_code: 200,
    //     paytab_token: "",
    //     amount: totalFee,
    //     discription:"",
    //     online_payment_amount:totalFee,
    //     actual_amount_paid:totalFee,
    //     chequeDetailsJson:{},
    //     paymentMode: "card",
    //     payment_source: "WEB",
    //     institute_id: `${props.institute_id}`,
    //     paid_date:new Date().toISOString().split('T')[0],
    //     razor_payment_id: "", 
    //     reference_no: "", 
    //     remarks: "", 
    //      schedule_ids: data,
    //       student_id: `${props.student_id}`,
    //    version: "v2",
    //     intent:"sale"
    //   };
      
    //       console.log("paypal payload", payload);
    //       const url = await getPaypalPaymentURL(payload);
    //       console.log("url",url)
    //       window.open(url.replace("redirect:", ""), "_self");
    //     } catch (err) {
    //       console.error("Redirect failed", err);
    //       alert("Could not proceed to payment.");
    //     } finally {
    //       props.setLoader(false);
    //     }
    //   };
  
    
    
        // let payload = {
        //   entity_id: order_data.entity_id,
        //   payment_gateway_transaction_id: "",
        //   status: 20,
        //   payment_for: "Product",
        //   payment_gateway_account_type: account,
        //   payment_gateway_name: gateway,
        //   country_id: this.state.country_id,
        //   currency_code: this.state.currency_code,
        //   response_code: 200,
        //   paytab_token: "",
        //   amount: this.state.total_amount - this.state.discount,
        //   payment_source: "WEB",
        //   institute_id: institute_id.toString(),
        //   user_id: user_id.toString(),
        //   offer_apply_dto:this.state.coupon_details,
        //   intent:"ORDER"
        // };
    
      
        

    const updateData = (data) => {
        setLoader(true);
        setPublicToken(data?.Razorpay?.public_token);
        setIsOAuthDone(data?.Razorpay?.is_oAuth_done);
        setGatewayData(data);
        setLoader(false);
    };
    
    
    return (
        <>
                <ToastContainer />

            {
                 loading && <Loader />
                 }
            <div>

                {/* {console.log("prop",props.currency_code)} */}
                <div id="due-dtl" className="tab-content">
                    <div className="d-flex align-items-center card-section">
                        <div className="card crd1">{t('fees.totalFees')}: {currencySymbol+" "+numToCurrency(props?.fetchStudent?.result?.total_fee_amount,props.currency_code)}</div>
                        <div className="card crd2">{t('fees.paidFees')}: {currencySymbol+" "+numToCurrency(props?.fetchStudent?.result?.total_paid_amount,props.currency_code)}</div>
                        <div className="card crd3">{t('fees.dueFees')}: {currencySymbol+" "+numToCurrency(props?.fetchStudent?.result?.total_unpaid_amount,props.currency_code)}</div>
                       
                    </div>
                    <div className='table-container'>
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </th> 
                                    <th>{t('fees.installmentNo')}</th>
                                    <th>{t('fees.date')}</th>
                                    {props.is_fee_struct_linked && (
                    <th>{props.is_institute_type_school ? t('profile.standard') : t('profile.batch')}</th>
                )}
                                    <th>{t('fees.totalAmount')}</th>
                                    {props.fineEnable && (
                                    <th>{t('fees.fineAmount')}</th>
                                    )}
                                    <th>{t('fees.balanceAmount')}</th>
                                    <th>{t('fees.status')}</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                {installments.length > 0 &&
                                installments.filter(
                                    (item) => getFeeStatus(item) !== "Paid" &&
                                            getFeeStatus(item) !== "Bad Debt" &&
                                            (item.d_amount + parseInt(item?.balance_fine ?? 0)) > 0 
                                ).length > 0 ? (
                                    installments
                                    .filter(
                                        (item) => getFeeStatus(item) !== "Paid" &&
                                                getFeeStatus(item) !== "Bad Debt" &&
                                                (item.d_amount + parseInt(item?.balance_fine ?? 0)) > 0 
                                    )
                                    .map((item, index) => (
                                        <tr key={index}>
 <td>
                        <input
                            type="checkbox"
                            checked={selectedInstallments.includes(item.f_schld_id)}
                            onChange={() => handleCheckboxChange(item.f_schld_id, item.install_no)}
                        />
                    </td>
                                            <td>{item.install_no}</td>
                                            <td>{item.d_date || "N/A"}</td>
                                            {props.is_fee_struct_linked && (
                                                <td className="batch-column" title={props.is_institute_type_school
                                ? item.stnd_n || "-"
                                : item.c_n || "-"
                              }>
                              {props.is_institute_type_school ? item.stnd_n || "-" : item.c_n || "-"}</td>                        )}                        
                                            <td>{item.c_code+" "+numToCurrency(item.t_amount ?? 0)}</td>
                                            {props.fineEnable && (
                                            <td>{item.c_code+" "+numToCurrency(item.balance_fine ?? 0)}</td>
                                            )}
<td>{item.c_code+" "+numToCurrency(item.d_amount + parseInt(item?.balance_fine ?? 0))}</td>
                                            <td>{getFeeStatus(item)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                    <td colSpan={props.is_fee_structure_linked ? "10" : "9"}>
                                        <div className="no-data-container">
                                            <p className="up-text2">{t('fees.noDataAvailable')}</p>
                                            <img src={noData} alt="No Data" className="no-data-img"/>
                                        </div>
                                    </td>
                                </tr>
                                
                                )}
                            </tbody>


                        </table>
                       
                    </div>
                    
                </div>
            </div>
         
            <div>
             <div className="button-container">
     <button 
         className="blue_button" 
         disabled={selectedInstallments.length === 0}
         onClick={handleProceedToPay} // ✅ Call function directly
     >
         Proceed to Pay
     </button>
 </div>
 {/* Modal should open only when isModalOpen is true */}
 {/* {isModalOpen && ( */}
    <PaymentGatewayModal 
    show={isModalOpen && props?.fetchStudent?.result?.c_symbol === "INR"}
    {...props}

      setLoader={setLoading}
      installments={installments}
      getFeeStatus={getFeeStatus}
      user_phone={props.user_phone}
      user_email={props.user_email}
      user_id={props.user_id}
      institute_id={props.institute_id}
      currency_code={props?.fetchStudent?.result?.currency_code}
      razorpay_fee={props.razorpay_fee}
      student_auth={props.student_auth}
      total_paid_amount={props?.fetchStudent?.result?.total_paid_amount}
      student_fee_enable={gatewayData?.inst_sett_det?.enable_razor_GST_fee_from_student}
      handleClose={() => setIsModalOpen(false)}
      selectedInstallments={paymentData}
      gatewayDta={gatewayDta} 
      total_amount={total_amount} 
      discount={discount} 
      changePaymentType={changePaymentType} 
      handleCheckboxChange={handleCheckboxChange}
      pr={gatewayData}
 />
  
  
{/* )} */}

             
             </div>

        </>
    );
}

export default Due_details;